export default __webpack_public_path__ + "media/images/cta_blocks/save_the_dates-a3763b3480d718c728f451f0ea5f15ab.jpg";